/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const MainInfoContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(4),
  marginTop: theme.spacing(6),
  alignItems: 'flex-start',
}));

export const MainParamsContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1px',
  width: '500px',
}));

export const BetaTestBlock = styled(Box)(({theme}) => ({
  background: theme.palette.semantic_dark?.alert?.container,
  padding: theme.spacing(4),
  display: 'flex',
  gap: theme.spacing(2),
  color: theme.palette.semantic_dark?.alert?.onContainer,
  fontSize: '14px',
  lineHeight: '16px',
  borderRadius: theme.spacing(2, 2, 0, 0),
}));

export const BetaTestText = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const GridContainer = styled(Box)(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 2fr',
  gridTemplateRows: 'repeat(3, auto)',
  gap: '1px',
  borderRadius: theme.spacing(0, 0, 2, 2),
  overflow: 'hidden',
}));

export const Cell = styled(Box)(({theme}) => ({
  padding: theme.spacing(4),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontSize: '14px',
  lineHeight: '16px',
  color: theme.palette.semantic_dark?.surface?.onSurface,
  boxSizing: 'content-box',

  // Левая колонка (1, 3, 5)
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.semantic_dark?.surface?.surface2,
    fontWeight: 500,
    width: '186px',
  },

  // Правая колонка (2, 4, 6)
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.semantic_dark?.surface?.surface1,
  },
}));
